import { Template } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";

const TemplatesTableSpaceCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<Template>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={template.space.id} fallbackName={template.space.name} />
    </TableSimpleCell>
  );
};

export default TemplatesTableSpaceCell;
